;(function( window, document, $, undefined ) {
	'use strict';

	// Adjustments

	function adjustments() {

    // Height
    function height( $el ) {
      var elHeight = 0;
      $el.css('height', 'auto');
      setTimeout(function(){
        $el.each(function(){
          var $this = $(this);
          var contentHeight = $this.outerHeight();
          if( contentHeight > elHeight ) {
            elHeight = contentHeight;
          }
        });
        $el.css('height', elHeight);
      }, 100);
    }

    // Width
    function width( $el ) {
      var elWidth = 0;
      $el.css('width', 'auto');
      setTimeout(function(){
        $el.each(function(){
          var $this = $(this);
          var contentWidth = $this.outerWidth();
          if( contentWidth > elWidth ) {
            elWidth = contentWidth;
          }
        });
        $el.css('width', elWidth);
      }, 100);
    }

		// Globals
		return {
      height: height,
      width: width
		};

	}

	// Globals
	window.callsource = window.callsource || {};
  window.callsource.adjustments = adjustments();

})( window, document, jQuery );
